/**
 * Authentication Helper Utilities
 *
 * Responsible for:
 * - Reading/writing JWT tokens
 * - Decoding token payload
 * - Validating expiration
 * - Logging the user out
 */

import { jwtDecode } from "jwt-decode";


/**
 * Returns the JWT token stored in the browser.
 */
export function getToken() {
    return sessionStorage.getItem("token");
}

/**
 * Decodes and returns payload from JWT.
 * Returns null if token is invalid or missing.
 */
export function getTokenPayload() {
    const token = getToken();
    if (!token) return null;

    try {
        return jwtDecode(token);
    } catch {
        return null;
    }
}

/**
 * Validates whether the stored token is still valid.
 * Checks:
 *   - token exists
 *   - expiration timestamp
 */
export function isTokenValid() {
    const payload = getTokenPayload();
    if (!payload?.exp) return false;

    // exp value is in seconds — convert to milliseconds
    const isExpired = payload.exp * 1000 < Date.now();
    return !isExpired;
}

/**
 * Logs the user out and clears authentication state.
 */
export function logout() {
    sessionStorage.removeItem("token");
}
